import { Component, OnInit, Input, Output, ViewChild, EventEmitter, OnChanges } from '@angular/core';
import { DxDataGridComponent } from "devextreme-angular";
import { custom } from 'devextreme/ui/dialog';
import { AmsNotifierService } from '../../../../../../../shared/services/ams-notifier.service';
import { LanguageService } from '../../../../../../../shared/services/language.service';
import { TimeService } from '../../../../../_api/services/time.service';

@Component({
  selector: 'app-edit-transport-time',
  templateUrl: './edit-transport-time.component.html',
  styleUrls: ['./edit-transport-time.component.css']
})
export class EditTransportTimeComponent implements OnInit, OnChanges {
  @ViewChild('datagriddx', {static:false}) dataGrid: DxDataGridComponent;
  @Input() gridDataSource: any;
  timeTypeDataSource: any;
  @Output() loading = new EventEmitter<boolean>(); //emit event to parent(project-portal.component) to show load indicator
  @Input() transport: any;
  @Input() newStatusId: number = 3; // status when inserting time posts
  @Input() newCategoryId: number = 8; // category when inserting time posts
  @Output() changed = new EventEmitter();

  validateHoursMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.23.Hours");
  validateMinutesMessage = this.languageService.LNG("Label.Cannot.Enter.More.Than.59.Minutes");
  validateTimeTypeMessage = this.languageService.LNG("Please.Select.Timetype"); 
  isEditingDisabled = false;
  newTime: any = { TimeTypeId: -1, Hours: null, Minutes: null }

  constructor(public languageService: LanguageService, private timeService: TimeService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    this.timeService.getTimeTypes()
      .subscribe((result: any) => { // success path

        this.timeTypeDataSource = result;
      }, error => { // error path;
    });
  }

  ngOnChanges() {
    this.isEditingDisabled = this.transport.TransportStatusId >= 4;
  }

  onEditorPreparing(e) {
    if(e.parentType == "dataRow"){

      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }
   }
  }

  createNewTime() {
    this.loading.emit(true);  
    console.log(this.newTime)
    
    if (this.isValid()) {
      let seconds = this.getSeconds(this.newTime.Hours, this.newTime.Minutes);

      let time = {
        TimeId: -1,
        CarrierId: this.transport.CarrierId,
        ProjectId: -1,
        TimeTypeId: this.newTime.TimeTypeId,
        Seconds: seconds,
        EmployeeId: this.transport.EmployeeId,
        Date: this.transport.Date,
        CategoryId: this.newCategoryId,
        StatusId: this.newStatusId,
        Comment: "",
        CustomRef: "",
      };

      this.timeService.insertTimeSalaryTime(time)
        .subscribe((result: any) => { 
          if (result.IsSuccess) {
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            this.gridDataSource.push(time); 
            this.refresh();
            this.newTime = { TimeTypeId: -1, Hours: null, Minutes: null }; 
          }
          else {
            this.loading.emit(false);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { 
          this.loading.emit(false);
      });
    }
  }

  isValid(): boolean {
    let isValid: boolean = true; 
    
    if (this.newTime.TimeType < 0) {
      this.amsNotifierService.error(this.validateTimeTypeMessage);
      isValid = false; 
    }
    if (this.newTime.Hours > 23) {
      this.amsNotifierService.error(this.validateHoursMessage);
      isValid = false; 
    }
    if (this.newTime.Minutes > 59) {
      this.amsNotifierService.error(this.validateMinutesMessage);
      isValid = false; 
    }

    return isValid; 
  }

  refresh() {
    this.loading.emit(true);
    this.timeService.getTimesByTransportCollection(this.transport.TransportCollectionId)
      .subscribe((result: any) => { // success path
        this.loading.emit(false);
        if (result.IsSuccess) {
          this.gridDataSource = result.Data;
          this.changed.emit();
        }
        else {
          this.amsNotifierService.error(result.ErrorMessage);
        }
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  getSeconds(hours, minutes): number {
    if (!hours) {
      hours = 0;
    }
    if (!minutes) {
      minutes = 0;
    }
    let newHHSeconds = hours * 3600;
    return newHHSeconds + (Number(minutes) * 60);
  }

  onRowUpdating(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      for (var property in e.oldData) {
        if (!e.newData.hasOwnProperty(property)) {
          e.newData[property] = e.oldData[property];
        }
      }
      let seconds = this.getSeconds(e.newData.TotSecondsToHH, e.newData.TotSecondsTomm);

      let time = {
        TimeId: e.newData.TimeId,
        CarrierId: this.transport.CarrierId,
        ProjectId: -1,
        TimeTypeId: e.newData.TimeTypeId,
        Seconds: seconds,
        EmployeeId: this.transport.EmployeeId,
        Date: this.transport.Date,
        CategoryId: 8,//transportcollection,
        Comment: "",
        CustomRef: "",
      };

      this.timeService.updateTimeSalaryTime(time)
        .subscribe((result: any) => { // success path

          this.loading.emit(false);
          if (result.IsSuccess) {
            resolve(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            e.component.cancelEditData();
            this.refresh();
          }
          else {
            this.loading.emit(false);
            resolve(true);
            this.amsNotifierService.error(result.ErrorMessage);
          }
        }, error => { // error path;
          this.loading.emit(false);
          resolve(true);
        });
    });
    e.cancel = isCanceled;
  }

  onRowRemoving(e: any) {
    let timeIds: number[] = [];
    timeIds.push(e.data.TimeId); 
    
    this.loading.emit(true);
    this.timeService.deleteTimeByTimeIds(timeIds).subscribe((result: any) => { 
      this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
      if (result.Message != null && result.Message.length > 0) {
        this.amsNotifierService.error(result.Message);
      }
      this.loading.emit(false);
      this.refresh();
      this.dataGrid.selectedRowKeys = [];
    }, error => { 
      this.loading.emit(false);
    });
  }

}
